module.exports = __webpack_public_path__ + "img/google-play.2d37ef68.png";